import { MOBILE_L_BP } from "@website-builder/utilities-index";
import styled from "styled-components";

export const Card = styled.a`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	width: 300px;
	text-decoration: none;

	flex: 100% 1 auto;

	.blog-image {
		object-fit: cover;
		width: 100%;
		max-width: 800px;
		border-radius: 8px;
		aspect-ratio: 4/3;
	}

	.date-of-publishing {
		color: var(--secondary-gray-dark);
		margin-top: 1rem;
		margin-bottom: 0.5rem;
	}

	//These media queries are tailored to make the spacing between the cards look good- so we haven't used constants here
	@media only screen and (max-width: 1470px) {
		width: 250px;
	}
	@media only screen and (max-width: 1270px) {
		width: 350px;
	}
	@media only screen and (max-width: 1170px) {
		width: 300px;
	}
	@media only screen and (max-width: 1050px) {
		width: 250px;
	}
	@media only screen and (max-width: 850px) {
		width: 300px;
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		width: 100%;
	}
`;
